import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { McticHttpClient, McticHttpParams, Page, Pageable } from '@mctic/ng-core';
import { Observable } from 'rxjs';
import { PessoaJuridica } from '../shared/model';
import { EnderecoFabrilPleitoVO } from '../shared/model/endereco-fabril-pleito-vo.model';
import { EntidadePessoaJuridicaVO } from '../shared/model/entidade-pessoa-juridica-vo.model';
import { IdentificacaoPleito } from "../shared/model/identificacao-pleito";
import { PleitoCancelarVO } from '../shared/model/pleito-cancelar-vo.model';
import { PleitoSimplificadoVO } from '../shared/model/pleito-simplificado-vo.model';
import { PleitoVO } from '../shared/model/pleito-vo.model';
import { ProrrogacaoExigenciaPleitoVO } from '../shared/model/prorrogacao-vo.model';
import { SolicitacaoPorrogacaoPrazoExigenciaVO } from '../shared/model/solicitacao-porrogacao-prazo-exigencia-vo.model';
import { TipoSituacaoPleitoVO } from '../shared/model/tipo-situacao-pleito-vo.model';

@Injectable({
  providedIn: 'root'
})
export class PleitoService {

  private readonly service = '/sepin-backend/rest/pleitos';

  constructor(private readonly http: McticHttpClient,
              private readonly httpClient: HttpClient) {
  }

  obterEntidadeAutenticado(idPleito: number): Observable<PessoaJuridica> {
    return this.http.get<PessoaJuridica>(`${this.service}/${idPleito}/entidades/autenticado`);
  }

  submeterPleitoAnalise(idPleito: number): Observable<any> {
    return this.http.put<any>(`${this.service}/submeter-analise/${idPleito}`, '' );
  }

  obterSolicitacoesPorrogacaoPrazoPleito(idPleito: number, pageable: Pageable): Observable<Page<SolicitacaoPorrogacaoPrazoExigenciaVO>> {
    const httpParams: McticHttpParams = new McticHttpParams();
    //httpParams.set('sort', 's.dtSolicitacao');
    httpParams.setPageable(pageable);
    const params: HttpParams = httpParams.toHttpParams();
    return this.http.get<Page<SolicitacaoPorrogacaoPrazoExigenciaVO>>(
      `${this.service}/prorrogacao-exigencia/lista/${idPleito}/`, {params});
  }

  obterEntidade(idPleito: number): Observable<EntidadePessoaJuridicaVO> {
    return this.http.get<EntidadePessoaJuridicaVO>(`${this.service}/${idPleito}/entidades`);
  }

  obterSolicitacaoProrrogacaoPrazoEmAberto(idPleito: number): Observable<SolicitacaoPorrogacaoPrazoExigenciaVO> {
    return this.http.get<SolicitacaoPorrogacaoPrazoExigenciaVO>(`${this.service}/prorrogacao-exigencia/analise-pendente/${idPleito}`);
  }

  obterTotalPrazoExigencia(idPleito: number): Observable<number> {
    return this.http.get<number>(`${this.service}/prorrogacao-exigencia/total-exigencia/${idPleito}`);
  }

  buscarSolicitacaoPorrogacaoPrazoId(idSolicitacao: number): Observable<SolicitacaoPorrogacaoPrazoExigenciaVO> {
    return this.http.get<SolicitacaoPorrogacaoPrazoExigenciaVO>(
      `${this.service}/prorrogacao-exigencia/${idSolicitacao}`);
  }

  analisarSolicitacaoProrrogacaoExigencia(solicitacaoPorrogacaoPrazoExigenciaVO: SolicitacaoPorrogacaoPrazoExigenciaVO): Observable<any> {
    return this.http.post<any>(`${this.service}/prorrogacao-exigencia/analisar`, solicitacaoPorrogacaoPrazoExigenciaVO);
  }

  obterPorId(idPleito: number): Observable<PleitoVO> {
    return this.http.get<PleitoVO>(`${this.service}/${idPleito}`);
  }

  obterPleitoCancelar(idPleito: number): Observable<PleitoCancelarVO> {
    return this.http.get<PleitoCancelarVO>(`${this.service}/pleito-cancelar/${idPleito}`);
  }

  cancelarPleito(idPleito: number, justificativa: string) {
    return this.http.post(`${this.service}/pleito-cancelar/${idPleito}`, justificativa);
  }

  consultar(form, pageable: Pageable): Observable<Page<PleitoVO>> {
    if (form.cnpj) {
      form.cnpj = form.cnpj.replace(/\D/g, '');
    }
    const queryParams = new McticHttpParams()
      .set('cnpj', form.cnpj)
      .set('empresa', form.empresa)
      .set('nomeProduto', form.nomeProduto)
      .set('nct', form.nct)
      .set('ncmIndicado', form.ncmIndicado)
      .set('nProcesso', form.nProcesso)
      .set('situacao', form.situacao)
      .setMoment('dataSubmissao', form.dataSubmissao)
      .setPageable(pageable);
    return this.http.get<any>(`${this.service}/query`, {params: queryParams.toHttpParams()});
  }
  cadastrar(pleito: any) {
    return this.http.post(this.service, pleito);
  }

  cadastrarIdentificacao(pleitoVO: PleitoVO): Observable<PleitoVO> {
    return this.http.post(`${this.service}/cadastrar/identificacao`, pleitoVO);
  }

  atualizarOutrasInformacoes(idPleito: number, outrasInfo: string, rascunho: boolean): Observable<PleitoVO> {
    return this.http.put(`${this.service}/cadastrar/outras-informacoes/${idPleito}/${rascunho}`, outrasInfo);
  }

  mudarStatusPleito(idPleito, status) {
    return this.http.put(`${this.service}/status/${idPleito}`, status);
  }

  atualizarSecretario(pleitoSecretario): Observable<any> {
    return this.http.put(`${this.service}/atualizar-secretario`, pleitoSecretario);
  }

  buscarDadosSecretario(idPleito: number): Observable<any> {
    return this.http.get(`${this.service}/atualizar-secretario/${idPleito}`);
  }

  relatorioPleito(idPleito) {
    const headers = new HttpHeaders();
    headers.append('Accept', 'application/pdf');
    return this.httpClient.get(`${this.service}/visualizar/${idPleito}`, {headers, observe: 'response', responseType: 'arraybuffer'});
  }

  remover(idPleito: number) {
    return this.http.delete(`${this.service}/${idPleito}`);
  }
  obterEnderecoFabrilPleito(idPleito: number): Observable<EnderecoFabrilPleitoVO> {
    return this.http.get<EnderecoFabrilPleitoVO>(`${this.service}/endereco-fabril/${idPleito}`);
  }

  obterSituacoesPleito(): Observable<TipoSituacaoPleitoVO[]> {
    return this.http.get<TipoSituacaoPleitoVO[]>(`${this.service}/listar-situacoes`);
  }

  obterSituacoesPleitoFiltro(nrOrdem): Observable<TipoSituacaoPleitoVO[]> {
    return this.http.get<TipoSituacaoPleitoVO[]>(`${this.service}/listar-situacoes/${nrOrdem}`);
  }

  obterPorNome(idPleito, nome): Observable<string[]> {
    return this.http.get<string[]>(`${this.service}/${idPleito}/razao-social/autocomplete/${nome}`);
  }

  obterPorNomeEmpresa(nome): Observable<string[]> {
    return this.http.get<string[]>(`${this.service}/razao-social/autocomplete/${nome}`);
  }

  obterPorCNPJEmpresa(cnpj): Observable<string[]> {
    return this.http.get<string[]>(`${this.service}/cnpj/autocomplete/${cnpj}`);
  }

  obterPorCNPJEmpresaAnalista(cnpj): Observable<string[]> {
    return this.http.get<string[]>(`${this.service}/cnpj/autocomplete/analista/${cnpj}`);
  }

  obterPorEntidade(idEntidade): Observable<number[]> {
    return this.http.get<number[]>(`${this.service}/porEntidade/${idEntidade}`);
  }

  solicitarProrrogacao(prorrogacao: ProrrogacaoExigenciaPleitoVO): Observable<ProrrogacaoExigenciaPleitoVO> {
    return this.http.post<ProrrogacaoExigenciaPleitoVO>(`${this.service}/solicitar-prorrogacao`, prorrogacao);
  }

  obterSimplesPorId(idPleito: number): Observable<PleitoSimplificadoVO> {
    return this.http.get<PleitoSimplificadoVO>(`${this.service}/simplificado/${idPleito}`);
  }

  relatorioPleitoHistoricoExigencias(idPleito: number) {
    const headers = new HttpHeaders();
    headers.append('Accept', 'application/pdf');
    return this.httpClient.get(`${this.service}/visualizar/historico-exigencias/${idPleito}`,
      {headers, observe: 'response', responseType: 'arraybuffer'});
  }

  relatorioPleitoHistoricoExigenciasEmpresa(idPleito: number) {
    const headers = new HttpHeaders();
    headers.append('Accept', 'application/pdf');
    return this.httpClient.get(`${this.service}/visualizar/historico-exigencias/empresa/${idPleito}`,
      {headers, observe: 'response', responseType: 'arraybuffer'});
  }

  buscarOutrasInformacoes(idPleito: number): Observable<PleitoVO> {
    return this.http.get(`${this.service}/outras-informacoes/${idPleito}`);
  }

  alterarpleitoSobrestamento(value: any) {
    return this.http.post<void>(`${this.service}/alterar-sobrestamento`, value);
  }

  enviarExigencia(value: any) {
    return this.http.post<void>(`${this.service}/enviar-exigencia`, value);
  }

  enviarRespostaExigencia(idPleito: any) {
    return this.http.post<void>(`${this.service}/enviar-resposta-exigencia/${idPleito}`, null);
  }

  consultarPorCnpj(cnpj: string): Observable<IdentificacaoPleito> {
    return this.http.get<IdentificacaoPleito>(`${this.service}/buscar-pessoa-juridica/${cnpj}`);
  }

  /*concluirAnalisePleito(idPleito: number): Observable<any> {
    return this.http.put<any>(`${this.service}/concluir-analise/${idPleito}`, {});
  }*/

  excluirCadastroPleito(idPleito: number) {
    return this.http.delete(`${this.service}/${idPleito}`);
  }

  obterCertidoes(idPleito: number) {
    return this.http.get<any>(`${this.service}/certidoes/${idPleito}`);
  }

  atualizarCertidoes(idPleito: number) {
    return this.http.put<any>(`${this.service}/certidoes/${idPleito}`, {});
  }

  obterPessoaJuridica(idPleito: number) {
    return this.http.get<any>(`${this.service}/pessoa-juridica/${idPleito}`);
  }

  parecerDispobilizadoSecretario(dados: any) {
    return this.http.post<void>(`${this.service}/parecer-disponibilizado`, dados);
  }
}
